import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import Loading from "../Loading";

export default function ChooseFreight({ isOpen, setIsOpen, freight }) {
  function closeModal() {
    setIsOpen(false);
    window.location.reload();
  }

  return freight && isOpen ? (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  Cotação realizada com sucesso!
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Protocolo: {freight?.protocol || "n/a"}
                  </p>
                </div>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Prazo de entrega: de {freight?.delivery_min || "n/a"} até{" "}
                    {freight?.delivery_max || "n/a"} dias
                  </p>
                </div>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Valor dos Produtos: R${" "}
                    {freight?.insurance_value.toFixed(2) || "n/a"}
                  </p>
                  <p className="text-sm text-gray-500">
                    Valor do Frete: R$ {freight?.price.toFixed(2) || "n/a"}
                  </p>
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={closeModal}
                  >
                    Fechar
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  ) : null;
}
